var L = Object.defineProperty;
var D = (e, t, i) => t in e ? L(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var c = (e, t, i) => D(e, typeof t != "symbol" ? t + "" : t, i);
import { isValid as u, parse as f, format as A } from "date-fns";
import { es as x, enUS as O } from "date-fns/locale";
import { useState as M, useCallback as F, useEffect as H } from "react";
import { z as n } from "zod";
import { AuthError as W } from "@aws-amplify/auth";
import * as r from "@sentry/react";
import { Amplify as b } from "aws-amplify";
function S() {
  return "dev.gcheckin.com";
}
function re(e) {
  if (!e)
    throw new Error("formAppUrl: publicId is required");
  return `https://${S()}/f/${e}`;
}
function ae(e) {
  if (!e)
    throw new Error("listingCheckinUrl: listingPublicId is required");
  return `https://${S()}/l/${e}`;
}
const k = /^[a-z0-9-]{3,40}$/;
function ce(e, t) {
  if (!e)
    throw new Error("formAppUrlBranded: publicId must be a non-empty string");
  const i = S();
  if (t && t.isActive && t.slug) {
    const s = t.slug.trim();
    if (s !== "" && k.test(s))
      return `https://${s}.${i}/f/${e}`;
  }
  return `https://${i}/f/${e}`;
}
const z = 4.5;
function de(e, t) {
  const i = P(e), s = P(t), o = T(i[0], i[1], i[2]), a = T(s[0], s[1], s[2]), h = Math.max(o, a), E = Math.min(o, a), v = (h + 0.05) / (E + 0.05), w = Math.round(v * 10) / 10;
  return { pass: w >= z, roundedRatio: w };
}
function T(e, t, i) {
  const s = g(e), o = g(t), a = g(i);
  return 0.2126 * s + 0.7152 * o + 0.0722 * a;
}
function g(e) {
  const t = e / 255;
  return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function P(e) {
  if (e == null)
    throw new Error("hex color is null/undefined");
  const t = e.startsWith("#") ? e.slice(1) : e;
  if (t.length !== 6 && t.length !== 8)
    throw new Error(`hex color must be 6 or 8 digits after '#': got ${e}`);
  if (!/^[0-9a-fA-F]{6,8}$/.test(t))
    throw new Error(`hex color contains non-hex characters: ${e}`);
  const i = parseInt(t.substring(0, 2), 16), s = parseInt(t.substring(2, 4), 16), o = parseInt(t.substring(4, 6), 16);
  return [i, s, o];
}
function C(e) {
  const t = e.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (t) {
    const [, i, s, o] = t;
    return new Date(parseInt(i, 10), parseInt(s, 10) - 1, parseInt(o, 10));
  }
  return new Date(e);
}
const l = {
  API: "yyyy-MM-dd",
  DISPLAY: "yyyy-MM-dd"
}, ue = {
  // Convert from display format to API format
  toAPIFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{4}-\d{2}-\d{2}$/)) return e;
    const t = f(e, l.DISPLAY, /* @__PURE__ */ new Date());
    return u(t) ? A(t, l.API) : "";
  },
  // Convert from API format to display format
  toDisplayFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{2}\.\d{2}\.\d{4}$/)) return e;
    const t = C(e);
    return u(t) ? A(t, l.DISPLAY) : "";
  },
  // Validate date string in display format
  isValidDisplayDate(e) {
    if (!e) return !1;
    const t = f(e, l.DISPLAY, /* @__PURE__ */ new Date());
    return u(t) && t <= /* @__PURE__ */ new Date();
  },
  // Parse any format to Date object
  parseAnyFormat(e) {
    if (!e) return null;
    let t = C(e);
    return u(t) ? t : (t = f(e, l.DISPLAY, /* @__PURE__ */ new Date()), u(t) ? t : null);
  }
};
var V = /* @__PURE__ */ ((e) => (e.IMAGE = "IMAGE", e.PDF = "PDF", e.EXTERNAL_URL = "EXTERNAL_URL", e.UNKNOWN = "UNKNOWN", e))(V || {});
const N = (e) => {
  if (!e) return "UNKNOWN";
  switch (e) {
    case "IMAGE":
      return "IMAGE";
    case "PDF":
      return "PDF";
    case "EXTERNAL_URL":
      return "EXTERNAL_URL";
    default:
      return "UNKNOWN";
  }
};
function le(e) {
  return N(e) === "IMAGE";
}
function me(e) {
  return N(e) === "PDF";
}
function he(e) {
  return N(e) === "EXTERNAL_URL";
}
const U = "preferred_dashboard_view", Ee = () => localStorage.getItem(U) || "listings", fe = (e) => {
  localStorage.setItem(U, e);
};
class G {
  constructor() {
    c(this, "notificationAudio", null);
    c(this, "isInitialized", !1);
    c(this, "audioUnlocked", !1);
  }
  /**
   * Initialize the audio element
   * Should be called after user interaction to comply with browser autoplay policies
   */
  initialize() {
    if (!this.isInitialized)
      try {
        this.notificationAudio = new Audio("/notification.wav"), this.notificationAudio.volume = 1, this.notificationAudio.preload = "auto", this.notificationAudio.load(), this.isInitialized = !0, console.debug("Sound manager initialized");
      } catch (t) {
        console.error("Failed to initialize sound manager:", t);
      }
  }
  /**
   * Register a one-time listener that unlocks audio on the user's first
   * interaction (click, tap, or key press). Browsers require a user gesture
   * before Audio.play() is allowed.
   */
  initAudioUnlock() {
    const t = ["pointerdown", "keydown"], i = () => {
      this.unlockAudio(), t.forEach((s) => document.removeEventListener(s, i));
    };
    t.forEach((s) => document.addEventListener(s, i, { once: !1 }));
  }
  unlockAudio() {
    if (this.audioUnlocked || (this.isInitialized || this.initialize(), !this.notificationAudio)) return;
    const t = this.notificationAudio.volume;
    this.notificationAudio.volume = 0, this.notificationAudio.play().then(() => {
      this.notificationAudio.pause(), this.notificationAudio.currentTime = 0, this.notificationAudio.volume = t, this.audioUnlocked = !0, console.debug("Sound manager audio unlocked");
    }).catch(() => {
      this.notificationAudio.volume = t;
    });
  }
  /**
   * Play the notification sound
   * Works even when tab is in background by using a persistent audio element
   * @returns Promise that resolves when sound starts playing
   */
  async playNotification() {
    try {
      if (this.isInitialized || this.initialize(), !this.notificationAudio)
        throw new Error("Audio element not initialized");
      this.notificationAudio.currentTime = 0, await this.notificationAudio.play(), console.debug("Notification sound played");
    } catch (t) {
      console.warn("Failed to play notification sound:", t);
    }
  }
  /**
   * Set the volume for notification sounds
   * @param volume - Volume level between 0 and 1
   */
  setVolume(t) {
    this.notificationAudio && (this.notificationAudio.volume = Math.max(0, Math.min(1, t)));
  }
  /**
   * Check if sound is initialized
   */
  isReady() {
    return this.isInitialized;
  }
}
const m = new G(), ge = {
  playNotification: () => m.playNotification(),
  initialize: () => m.initialize(),
  initAudioUnlock: () => m.initAudioUnlock(),
  setVolume: (e) => m.setVolume(e),
  isReady: () => m.isReady()
}, Ie = (e) => {
  const t = document.getElementById(e);
  if (t) {
    const i = document.querySelector("header"), s = i ? i.offsetHeight : 0, a = t.getBoundingClientRect().top + window.pageYOffset - s;
    window.scrollTo({
      top: a,
      behavior: "smooth"
    });
  }
}, _e = {
  h1: {
    size: "75px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h2: {
    size: "60px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h3: {
    size: "45px",
    lineHeight: "1.2",
    letterSpacing: "-0.01em",
    fontWeight: 700
  },
  h4: {
    size: "30px",
    lineHeight: "1.2",
    fontWeight: 700
  },
  body: {
    size: "16px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodyLarge: {
    size: "18px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodySmall: {
    size: "14px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  caption: {
    size: "12px",
    lineHeight: "1.5",
    fontWeight: 400
  }
}, $ = {
  en: O,
  es: x
  // …add more mappings when you introduce new languages
};
function pe(e) {
  const t = (e || navigator.language).split("-")[0] ?? "en";
  return $[t] ?? O;
}
const Se = "guardian_device_trust", Ne = "cognitoDeviceKey", we = {
  USER_SRP_AUTH: "USER_SRP_AUTH",
  USER_PASSWORD_AUTH: "USER_PASSWORD_AUTH",
  // Note: Disables device tracking
  CUSTOM_WITH_SRP: "CUSTOM_WITH_SRP",
  CUSTOM_WITHOUT_SRP: "CUSTOM_WITHOUT_SRP",
  USER_AUTH: "USER_AUTH"
}, _ = {
  minLength: 8,
  requireUppercase: !0,
  requireLowercase: !0,
  requireNumbers: !0,
  requireSpecialChars: !1
}, Ae = {
  INVALID_CREDENTIALS: "InvalidCredentialsException",
  USER_NOT_CONFIRMED: "UserNotConfirmedException",
  USER_NOT_FOUND: "UserNotFoundException",
  USERNAME_EXISTS: "UsernameExistsException",
  CODE_MISMATCH: "CodeMismatchException",
  EXPIRED_CODE: "ExpiredCodeException",
  LIMIT_EXCEEDED: "LimitExceededException",
  SESSION_EXPIRED: "SessionExpiredException",
  INVALID_PARAMETER: "InvalidParameterException",
  TOO_MANY_REQUESTS: "TooManyRequestsException"
}, B = {
  NotAuthorizedException: "Invalid email or password",
  UserNotConfirmedException: "Please verify your email address",
  UserNotFoundException: "No account found with this email",
  UsernameExistsException: "An account with this email already exists",
  CodeMismatchException: "Invalid verification code",
  ExpiredCodeException: "Verification code has expired",
  LimitExceededException: "Too many attempts. Please try again later",
  InvalidPasswordException: "Password does not meet requirements",
  InvalidParameterException: "Invalid parameters provided",
  TooManyRequestsException: "Too many requests. Please try again later"
}, Te = {
  // Email MFA challenges
  EMAIL_CODE: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
  EMAIL_OTP: "EMAIL_OTP",
  EMAIL_CUSTOM: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // SMS MFA challenges
  SMS: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  SMS_CODE: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  // TOTP MFA challenges
  TOTP: "CONFIRM_SIGN_IN_WITH_TOTP_CODE",
  TOTP_MFA: "CONFIRM_SIGN_IN_WITH_TOTP_MFA_CODE",
  SOFTWARE_TOKEN: "CONFIRM_SIGN_IN_WITH_SOFTWARE_TOKEN_MFA_CODE",
  // New password required
  NEW_PASSWORD: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  // Custom challenges
  CUSTOM_CHALLENGE: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // MFA selection
  MFA_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
  MFA_SETUP_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
  // TOTP setup
  TOTP_SETUP: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
  EMAIL_SETUP: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
}, Pe = "trusted_device_status", Ce = "mfa_session_data", Re = 6, Oe = 5, Me = 30, Ue = 3, ye = 30, ve = () => {
  const [e, t] = M({
    isValid: !1,
    hasMinLength: !1,
    hasUppercase: !1,
    hasLowercase: !1,
    hasNumber: !1,
    hasSpecialChar: !1,
    score: 0
  }), i = F((s) => {
    const o = {
      hasMinLength: s.length >= _.minLength,
      hasUppercase: /[A-Z]/.test(s),
      hasLowercase: /[a-z]/.test(s),
      hasNumber: /\d/.test(s),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(s),
      score: 0,
      isValid: !1
    };
    let a = 0;
    return Object.entries(o).forEach(([h, E]) => {
      h !== "score" && h !== "isValid" && E && (a += 20);
    }), o.score = a, o.isValid = a >= 60, t(o), o;
  }, []);
  return {
    strength: e,
    validatePassword: i
  };
};
function Y(e) {
  return typeof window > "u" ? !1 : window.matchMedia(e).matches;
}
function Le(e) {
  const [t, i] = M(() => Y(e));
  return H(() => {
    const s = window.matchMedia(e);
    i(s.matches);
    const o = () => i(s.matches);
    return s.addEventListener("change", o), () => s.removeEventListener("change", o);
  }, [e]), t;
}
const y = n.string().min(_.minLength, {
  message: `Password must be at least ${_.minLength} characters`
}).regex(/[a-z]/, {
  message: "Password must contain at least one lowercase letter"
}).regex(/[A-Z]/, {
  message: "Password must contain at least one uppercase letter"
}).regex(/\d/, { message: "Password must contain at least one number" }), De = n.object({
  email: n.string().email({ message: "Invalid email address" }),
  password: y,
  confirmPassword: n.string(),
  firstName: n.string().min(2, { message: "First name must be at least 2 characters" }),
  lastName: n.string().min(2, { message: "Last name must be at least 2 characters" })
}).refine((e) => e.password === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
}), xe = n.object({
  email: n.string().email({ message: "Invalid email address" }),
  password: n.string().min(1, { message: "Password is required" })
}), Fe = n.object({
  email: n.string().email({ message: "Invalid email address" })
}), He = n.object({
  code: n.string().min(1, "Verification code is required"),
  newPassword: n.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: n.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords must match",
  path: ["confirmPassword"]
}), We = n.object({
  code: n.string().min(6, { message: "Invalid confirmation code" })
}), be = n.object({
  currentPassword: n.string().min(1, "Current password is required"),
  newPassword: n.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: n.string().min(1, "Please confirm your password")
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"]
}), ke = n.object({
  newPassword: y,
  confirmPassword: n.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});
class R extends Error {
  constructor(t, i, s) {
    super(i), this.code = t, this.message = i, this.originalError = s, this.name = "AuthenticationError";
  }
}
const ze = (e) => {
  if (e instanceof W) {
    const t = B[e.name] || e.message;
    return new R(e.name, t, e);
  }
  return new R(
    "UnknownError",
    "An unexpected authentication error occurred",
    e instanceof Error ? e : void 0
  );
}, Ve = {
  save(e) {
    localStorage.setItem("unconfirmedAccount", e);
  },
  get() {
    return localStorage.getItem("unconfirmedAccount");
  },
  clear() {
    localStorage.removeItem("unconfirmedAccount");
  }
};
var q = /* @__PURE__ */ ((e) => (e.LOW = "low", e.MEDIUM = "medium", e.HIGH = "high", e.CRITICAL = "critical", e))(q || {}), K = /* @__PURE__ */ ((e) => (e.NETWORK = "network", e.AUTH = "auth", e.VALIDATION = "validation", e.SERVER = "server", e.TIMEOUT = "timeout", e.RATE_LIMIT = "rate_limit", e.NOT_FOUND = "not_found", e.PERMISSION = "permission", e))(K || {});
class I {
  static classify(t, i) {
    const s = {
      category: "network",
      severity: "medium",
      isRetryable: !0,
      shouldShowToast: !0,
      originalError: t,
      endpoint: i
    };
    return this.isAxiosError(t) ? this.classifyAxiosError(t, s) : t instanceof Error ? this.classifyByErrorMessage(t, s) : s;
  }
  static classifyByErrorMessage(t, i) {
    const s = t.message.toLowerCase();
    return s.includes("failed to fetch") || s.includes("network error") || s.includes("connection refused") ? {
      ...i,
      category: "network",
      severity: this.getNetworkErrorSeverity(i.endpoint),
      isRetryable: !0,
      shouldShowToast: this.shouldShowNetworkToast(i.endpoint),
      userMessage: this.getNetworkErrorMessage(i.endpoint)
    } : s.includes("timeout") || s.includes("abort") ? {
      ...i,
      category: "timeout",
      severity: this.getTimeoutSeverity(i.endpoint),
      isRetryable: !0,
      shouldShowToast: !this.isNonCriticalEndpoint(i.endpoint)
    } : i;
  }
  static classifyAxiosError(t, i) {
    var o;
    const s = (o = t.response) == null ? void 0 : o.status;
    if (!s)
      return {
        ...i,
        category: "network",
        severity: this.getNetworkErrorSeverity(i.endpoint),
        isRetryable: !0,
        shouldShowToast: this.shouldShowNetworkToast(i.endpoint)
      };
    switch (!0) {
      case s === 401:
        return {
          ...i,
          category: "auth",
          severity: "high",
          isRetryable: !1,
          shouldShowToast: !1
          // Handle auth errors separately
        };
      case s === 403:
        return {
          ...i,
          category: "permission",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints (user likely lacks permission)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(i.endpoint)
        };
      case s === 404:
        return {
          ...i,
          category: "not_found",
          severity: this.isNonCriticalEndpoint(i.endpoint) ? "low" : "medium",
          isRetryable: !1,
          shouldShowToast: !this.isNonCriticalEndpoint(i.endpoint)
        };
      case s === 429:
        return {
          ...i,
          category: "rate_limit",
          severity: "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      case (s >= 400 && s < 500):
        return {
          ...i,
          category: "validation",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints on 400 errors (likely permission issues)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(i.endpoint)
        };
      case s >= 500:
        return {
          ...i,
          category: "server",
          severity: this.isCriticalEndpoint(i.endpoint) ? "high" : "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      default:
        return i;
    }
  }
  static isAxiosError(t) {
    return (t == null ? void 0 : t.isAxiosError) === !0;
  }
  static isNonCriticalEndpoint(t) {
    return t ? this.NON_CRITICAL_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static isCriticalEndpoint(t) {
    return t ? this.CRITICAL_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static isPermissionSensitiveEndpoint(t) {
    return t ? this.PERMISSION_SENSITIVE_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static getNetworkErrorSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : this.isNonCriticalEndpoint(t) ? "low" : "medium";
  }
  static getTimeoutSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : "low";
  }
  static shouldShowNetworkToast(t) {
    return !this.isNonCriticalEndpoint(t);
  }
  static getNetworkErrorMessage(t) {
    return this.isNonCriticalEndpoint(t) ? "Some features may not be up to date" : "Connection issue detected. Please check your internet connection.";
  }
}
c(I, "NON_CRITICAL_ENDPOINTS", [
  "/activities/unread/count",
  "/notifications/count",
  "/stats/summary",
  "/health",
  "/ping"
]), c(I, "CRITICAL_ENDPOINTS", [
  "/auth/",
  "/profile",
  "/users/me"
]), // Endpoints that should suppress toast errors on 400/403 (permission issues)
c(I, "PERMISSION_SENSITIVE_ENDPOINTS", [
  "/calendar/form-present-between-dates",
  "/forms/calendar",
  "/listings",
  "/forms"
]);
class X extends Error {
  constructor(t = "Failed to connect to the server") {
    super(t), this.name = "ConnectionError";
  }
}
const j = (e) => e instanceof Error ? e.message.includes("Failed to fetch") || e.message.includes("Network Error") || e.message.includes("CONNECTION_REFUSED") || e.message.includes("ECONNREFUSED") || e.message.toLowerCase().includes("network") || e.message.includes("timeout") || e.message.includes("abort") || e.message.includes("Failed to connect") || e.name && [
  "NetworkError",
  "AbortError",
  "TimeoutError",
  "ConnectionError"
].includes(e.name) || e instanceof X : !1, Ge = (e) => ({
  name: "CONNECTION_ERROR",
  code: 0,
  message: j(e) ? e.message : "Failed to connect to the server",
  errorId: "CONN001"
}), $e = (e) => {
  if (!e) {
    r.setUser(null);
    return;
  }
  r.setUser({
    id: e.userId,
    // Consider hashing email or using a unique identifier instead
    email: e.email ? Q(e.email) : void 0
  }), r.setContext("user_info", {
    role: e.role,
    hasEmail: !!e.email
  });
}, Be = (e) => {
  r.setContext("form_context", {
    formId: e.formId,
    listingId: e.listingId,
    currentStep: e.step,
    totalSteps: e.totalSteps
  });
}, Ye = () => {
  r.setContext("form_context", null);
}, qe = (e, t) => {
  r.addBreadcrumb({
    category: "form",
    message: `Form step: ${e}`,
    level: "info",
    data: {
      step: e,
      ...t
    }
  });
}, Ke = (e, t) => {
  r.addBreadcrumb({
    category: "navigation",
    message: `Navigated from ${e} to ${t}`,
    level: "info",
    data: { from: e, to: t }
  });
}, Xe = (e, t) => {
  r.addBreadcrumb({
    category: "auth",
    message: e,
    level: "info",
    data: t
  });
}, je = (e, t, i, s) => {
  r.addBreadcrumb({
    category: "api",
    message: `${e} ${t}`,
    level: s ? "error" : "info",
    data: {
      method: e,
      url: t,
      status: i,
      error: s
    }
  });
}, Qe = (e, t) => {
  r.addBreadcrumb({
    category: "user_action",
    message: e,
    level: "info",
    data: t
  });
}, Ze = (e, t) => {
  r.addBreadcrumb({
    category: "validation",
    message: `Validation error on ${e}`,
    level: "warning",
    data: {
      field: e,
      error: t
    }
  });
}, Je = (e, t, i, s) => {
  r.addBreadcrumb({
    category: "file_upload",
    message: `File upload: ${e}`,
    level: s ? "info" : "error",
    data: {
      fileName: e,
      fileSize: t,
      fileType: i,
      success: s
    }
  });
}, et = (e, t) => {
  t && r.setContext("error_context", t), r.captureException(e);
}, tt = (e, t = "info") => {
  r.captureMessage(e, t);
};
function Q(e) {
  let t = 0;
  for (let i = 0; i < e.length; i++) {
    const s = e.charCodeAt(i);
    t = (t << 5) - t + s, t = t & t;
  }
  return `user_${Math.abs(t)}`;
}
const d = class d {
  constructor() {
    c(this, "isConfigured", !1);
  }
  static getInstance() {
    return d.instance || (d.instance = new d()), d.instance;
  }
  configure(t) {
    if (this.isConfigured) {
      console.warn("AWS is already configured");
      return;
    }
    this.validateParams(t);
    const i = {
      Auth: {
        Cognito: {
          userPoolId: t.userPoolId,
          userPoolClientId: t.userPoolClientId,
          region: t.region,
          authenticationFlowType: "USER_SRP_AUTH",
          signUpVerificationMethod: "code",
          loginWith: {
            email: !0,
            phone: !1,
            username: !1
          },
          passwordFormat: {
            minLength: 8,
            requireLowercase: !0,
            requireUppercase: !0,
            requireNumbers: !0,
            requireSpecialCharacters: !1
          }
        }
      }
    };
    try {
      b.configure(i), this.isConfigured = !0, console.info("AWS configuration completed successfully");
    } catch (s) {
      throw console.error("Failed to configure AWS:", s), new Error("AWS configuration failed");
    }
  }
  validateParams(t) {
    const i = [];
    if (t.region || i.push("region"), t.userPoolId || i.push("userPoolId"), t.userPoolClientId || i.push("userPoolClientId"), i.length > 0)
      throw new Error(
        `Missing required AWS config parameters: ${i.join(", ")}`
      );
  }
  isAWSConfigured() {
    return this.isConfigured;
  }
};
c(d, "instance");
let p = d;
const it = p.getInstance();
export {
  z as AA_THRESHOLD,
  Ae as AUTH_ERROR_CODES,
  we as AUTH_FLOW_TYPES,
  B as AuthErrorMessages,
  R as AuthenticationError,
  X as ConnectionError,
  Ne as DEVICE_KEY_STORAGE,
  Pe as DEVICE_STORAGE_KEY,
  Me as DEVICE_TRUST_DURATION_DAYS,
  Se as DEVICE_TRUST_KEY,
  l as DateFormats,
  K as ErrorCategory,
  I as ErrorClassifier,
  q as ErrorSeverity,
  V as FileKind,
  Ue as MAX_MFA_ATTEMPTS,
  Te as MFA_CHALLENGE_TYPES,
  Oe as MFA_CODE_EXPIRY_MINUTES,
  Re as MFA_CODE_LENGTH,
  ye as MFA_RETRY_DELAY_SECONDS,
  Ce as MFA_SESSION_KEY,
  _ as PASSWORD_REQUIREMENTS,
  je as addApiBreadcrumb,
  Xe as addAuthBreadcrumb,
  Je as addFileUploadBreadcrumb,
  qe as addFormSubmissionBreadcrumb,
  Ke as addNavigationBreadcrumb,
  Qe as addUserActionBreadcrumb,
  Ze as addValidationErrorBreadcrumb,
  it as awsConfig,
  et as captureException,
  tt as captureMessage,
  be as changePasswordSchema,
  Ye as clearSentryFormContext,
  We as confirmSignUpSchema,
  Ge as createConnectionError,
  ue as dateUtils,
  ze as enhancedAuthErrorHandler,
  Fe as forgotPasswordSchema,
  re as formAppUrl,
  ce as formAppUrlBranded,
  pe as getDateFnsLocale,
  N as getFileKind,
  Ee as getPreferredDashboardView,
  j as isConnectionError,
  he as isExternalUrl,
  le as isImage,
  me as isPdf,
  g as linearize,
  ae as listingCheckinUrl,
  T as luminance,
  ke as newPasswordSchema,
  P as parseHex,
  C as parseLocalDate,
  He as resetPasswordSchema,
  Ie as scrollToSection,
  fe as setPreferredDashboardView,
  Be as setSentryFormContext,
  $e as setSentryUserContext,
  xe as signInSchema,
  De as signUpSchema,
  ge as soundUtils,
  _e as typography,
  Ve as unconfirmedAccountManager,
  Le as useMediaQuery,
  ve as usePasswordValidator,
  de as validateContrast
};
